import { SaveIntegrationWebComponent } from './component/SaveIntegrationWebComponent';
import { WEB_COMPONENT_SAVE_INTEGRATION } from '../../webcomponents.constants';

export { SaveIntegrationWebComponent };

window.customElements.define(WEB_COMPONENT_SAVE_INTEGRATION, SaveIntegrationWebComponent);
